"use client";

import Link from "next/link";
import { I } from "@/components/kamibot-v2/discord";

type PremiumNavProps = {
  theme: "light" | "dark";
  setTheme: (t: "light" | "dark") => void;
};

export function PremiumNav({ theme, setTheme }: PremiumNavProps) {
  return (
    <nav className="prem-nav">
      <div className="shell prem-nav-inner">
        <Link className="brand" href="/">
          <span className="brand-mark">
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src="/kamibot-character/kamibot-portrait.png" alt="" />
          </span>
          <span className="brand-name">카미봇</span>
          <span className="brand-divider" />
          <span className="brand-page">멤버십 · 프리미엄</span>
        </Link>

        <div className="prem-nav-links">
          <a className="prem-nav-link" href="#plans">플랜</a>
          <a className="prem-nav-link" href="#costs">운영</a>
          <a className="prem-nav-link" href="#compare">비교</a>
          <a className="prem-nav-link" href="#faq">FAQ</a>
        </div>

        <div className="prem-nav-side">
          <Link className="prem-nav-link" href="/">메인으로</Link>
          <button
            type="button"
            className="theme-btn"
            aria-label="테마 전환"
            onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          >
            {theme === "dark" ? <I.sun /> : <I.moon />}
          </button>
        </div>
      </div>
    </nav>
  );
}
